import { BasicRequest } from "./basicRequest";

export class EnableBillingBucketRequest extends BasicRequest{
    public billingBucketId!:number;
    public enable:boolean = false;
}